import { trpc } from '@/shared/api';

interface UseIdentityAvailabilityQueryOptions {
  readonly enabled?: boolean;
}

/**
 * 본인인증 사용 여부(identity.availability) — 비로그인·공개 화면이 본인인증 안내를 그릴지 정한다.
 *
 * 서버 설정(IDENTITY_PROVIDER)이라 서버 재시작 전에는 바뀌지 않으므로 다시 받지 않는다.
 * 불러오는 중·실패면 화면은 본인인증 문구를 그리지 않는다(`data?.identityRequired === true` 일 때만).
 * 안내를 그리지 않는 화면은 enabled=false 로 요청을 미룬다.
 */
export const useIdentityAvailabilityQuery = (options?: UseIdentityAvailabilityQueryOptions) =>
  trpc.identity.availability.useQuery(undefined, {
    staleTime: Number.POSITIVE_INFINITY,
    enabled: options?.enabled,
  });
